export default __webpack_public_path__ + "img/the-data-analysis-process-1.1a68c34c.jpg";